import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Icon } from "@ugc-ui/lego";
import { ModalContentWrapperStyled } from "@common/components/Modal/ModalTemplate/ModalContentWrapper/ModalContentWrapper.styled";

export const ModalVideoPlayerContentClassName = css`
  text-align: center;

  &${ModalContentWrapperStyled} {
    padding: 0;
  }
`;

export const BackButton = styled(Icon)`
  position: absolute;
  z-index: 4;
  top: 16px;
  left: 16px;
`;
